import { readGlobalEntryHandoff } from "./globalEntryHandoff";

export const STUDY_ACCESS_PATH = "/study-access";
export const FORM_PATH = "/form";

function appendParams(path, params) {
  const serialized = params.toString();
  return serialized ? `${path}?${serialized}` : path;
}

function buildHandoffParams(search) {
  const handoff = readGlobalEntryHandoff(search);
  const params = new URLSearchParams();

  if (handoff.clinicStudyId) {
    params.set("clinicStudyId", handoff.clinicStudyId);
  }

  if (handoff.subjectId) {
    params.set("subjectId", handoff.subjectId);
  }

  if (handoff.inviteToken) {
    params.set("inviteToken", handoff.inviteToken);
  }

  if (handoff.lng) {
    params.set("lng", handoff.lng);
  }

  if (handoff.source) {
    params.set("source", handoff.source);
  }

  return params;
}

export function buildStudyAccessPath({ search = "", next = null } = {}) {
  const params = buildHandoffParams(search);

  if (next) {
    params.set("next", next);
  }

  return appendParams(STUDY_ACCESS_PATH, params);
}

export function buildFormPath({ search = "", next = null } = {}) {
  const params = buildHandoffParams(search);

  if (next) {
    params.set("next", next);
  }

  return appendParams(FORM_PATH, params);
}
